import { type FC } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { featuresSelector } from '@/support/Selectors';
import ExecuteSamplesCollectStep from './ExecuteSamplesCollectStep';
import ExecuteSamplesCollectStepV2 from './ExecuteSamplesCollectStepV2';

const featureSelector = createSelector([featuresSelector], (features) => ({
  samplingSheets: features?.sampling_sheets ?? false,
}));

const ExecuteSamplesCollectStepWrapper: FC = () => {
  const { samplingSheets } = useSelector(featureSelector);
  return samplingSheets ? <ExecuteSamplesCollectStepV2 /> : <ExecuteSamplesCollectStep />;
};

export default ExecuteSamplesCollectStepWrapper;
